module.exports = __webpack_public_path__ + "img/help_delivery_key_pl.9737b5dc.png";